import type { CapabilityErrorUnion } from '../capabilityError';
import { makeCapabilityErrors } from '../capabilityError';

/**
 * What `ProductCatalogue` reports when a read does not answer.
 *
 * `NotFound` is a 404, `ContractMismatch` a body the curated schema rejects,
 * and `Unavailable` everything else — any other status, and the network. A
 * loader matches on these three and never on the tenant error the adapter
 * mapped from.
 */
export const ProductCatalogueError = makeCapabilityErrors('ProductCatalogue');

export type ProductCatalogueError = CapabilityErrorUnion<typeof ProductCatalogueError>;
